import { Text, View } from '@react-pdf/renderer';

import { Info } from 'interfaces/components/dashboardPdf';

interface InfoContainerProps {
  info: Info;
}

export const InfoContainer = ({ info }: InfoContainerProps) => {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
      }}
    >
      <Text
        style={{
          paddingBottom: '4px',
          fontSize: '11px',
          fontWeight: 'semibold',
          color: '#5C5C5C',
          borderBottom: '1px solid #F2F2F2'
        }}
      >
        {info.header}
      </Text>

      {info.data.map(data => (
        <View
          key={data.label}
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems:
              typeof data.value === 'string' ? 'center' : 'flex-start',
            gap: '8px',
            paddingBottom: '4px',
            borderBottom: '1px solid #F2F2F2'
          }}
        >
          <View>
            <Text
              style={{
                fontSize: '9px',
                fontWeight: 'light',
                color: '#5C5C5C'
              }}
            >
              {data.label}
            </Text>

            {!!data.subLabel && (
              <Text
                style={{
                  fontSize: '9px',
                  fontWeight: 'light',
                  color: '#5C5C5C'
                }}
              >
                {data.subLabel}
              </Text>
            )}
          </View>

          {typeof data.value === 'string' && (
            <Text
              style={{ fontSize: '9px', fontWeight: 'light', color: '#151515' }}
            >
              {data.value}
            </Text>
          )}

          {data.type === 'multiple' && Array.isArray(data.value) && (
            <View
              style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}
            >
              {data.value.map(value => (
                <Text
                  key={value}
                  style={{
                    fontSize: '9px',
                    fontWeight: 'light',
                    color: '#151515'
                  }}
                >
                  {value}
                </Text>
              ))}
            </View>
          )}
        </View>
      ))}
    </View>
  );
};
